import { render, staticRenderFns } from "./passoApasso.vue?vue&type=template&id=8d622596&scoped=true&"
import script from "./passoApasso.vue?vue&type=script&lang=js&"
export * from "./passoApasso.vue?vue&type=script&lang=js&"
import style0 from "./passoApasso.vue?vue&type=style&index=0&id=8d622596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d622596",
  null
  
)

export default component.exports